/**
 * Flag-row accent colours for the Payroll Entry Summary table.
 *
 * Each employee row that needs attention is colour-coded with a 3px left
 * accent bar plus a faint tinted full-row background. This pure helper maps a
 * flag to those two colours so the table and any other consumer stay in sync.
 *
 * @param {{ kind?: string, label?: string } | null | undefined} flag
 *   The row flag, e.g. `{ kind: 'starter', label: 'New starter' }`.
 * @returns {{ bar: string, bg: string }}
 *   CSS colour strings for the accent bar and row background. Returns
 *   transparent for both when there is no flag.
 */
export function rowAccent(flag) {
  if (!flag || !flag.kind) return { bar: 'transparent', bg: 'transparent' };
  const map = {
    starter: { bar: '#10b981', bg: 'rgba(16,185,129,0.06)' },
    leaver:  { bar: '#f43f5e', bg: 'rgba(244,63,94,0.06)'  },
    warn:    { bar: '#f59e0b', bg: 'rgba(245,158,11,0.05)' },
    recent:  { bar: '#0ea5e9', bg: 'rgba(14,165,233,0.05)' },
    backpay: { bar: '#ea580c', bg: 'rgba(234,88,12,0.06)'  },
    addition: { bar: '#0d9488', bg: 'rgba(13,148,136,0.05)' },
    change:  { bar: '#f59e0b', bg: 'rgba(245,158,11,0.05)' },
    note:    { bar: '#8b5cf6', bg: 'rgba(139,92,246,0.05)' },
  };
  return map[flag.kind] || map.warn;
}

export default rowAccent;
